export interface ISolarAdditionalCustomerDetailsRequest {
  igsCustomerNumber: string;
}

export class SolarAdditionalCustomerDetailsRequest
  implements ISolarAdditionalCustomerDetailsRequest {
  igsCustomerNumber: string;

  constructor(igsCustomerNumber?: string) {
    this.igsCustomerNumber = igsCustomerNumber;
  }
}
